import { Container, Graphics } from "pixi.js";
import { HORIZON, bench, building, outdoor, tree } from "./common.js";

/**
 * La explanada de la FIEC: el patio abierto entre los bloques.
 *
 * Los tres edificios del fondo están en el mismo orden que sus puertas —11C a la
 * izquierda, 11B y 11A a la derecha— porque es lo que convierte al fondo en un mapa:
 * caminas hacia el edificio que ves, no hacia un cartel.
 */
export function plazoleta(): Container {
  const scene = outdoor({ ground: 0xd8d2c4, hedge: 0x4c9c5b });

  scene.addChild(building(60, 92, 250, 150, 0xe8e0d2));
  scene.addChild(building(560, 78, 200, 164, 0xdfd7c8));
  scene.addChild(building(770, 110, 170, 132, 0xe8e0d2));

  // Baldosa grande, sólo en el patio: es lo que lo separa de la calle y del césped.
  const paving = new Graphics();
  for (let i = 0; i <= 10; i++) {
    const x = 96 * i;
    paving.moveTo(x, HORIZON).lineTo(x + (x - 480) * 0.5, 540);
  }
  for (let i = 1; i < 6; i++) {
    const y = HORIZON + (540 - HORIZON) * (i / 6) ** 1.3;
    paving.moveTo(0, y).lineTo(960, y);
  }
  paving.stroke({ width: 1, color: 0xb3ab9b, alpha: 0.8 });
  scene.addChild(paving);

  scene.addChild(tree(120, HORIZON + 30, 0.9));
  scene.addChild(tree(860, HORIZON + 34, 0.9));
  scene.addChild(bench(700, 470, 110));

  return scene;
}
